<script setup lang="ts">
import { ref, onMounted, onBeforeUnmount } from 'vue'

const wrapperRef = ref<HTMLDivElement | null>(null)

const handlePointerMove = (event: PointerEvent) => {
  if (wrapperRef.value) {
    wrapperRef.value.style.setProperty('--mx', `${event.clientX}px`)
    wrapperRef.value.style.setProperty('--my', `${event.clientY}px`)
    wrapperRef.value.style.setProperty('--pointer-opacity', '1')
  }
}

const handlePointerLeave = () => {
  if (wrapperRef.value) {
    wrapperRef.value.style.setProperty('--pointer-opacity', '0')
  }
}

onMounted(() => {
  if (typeof window !== 'undefined') {
    window.addEventListener('pointermove', handlePointerMove, { passive: true })
    document.body.addEventListener('pointerleave', handlePointerLeave, { passive: true })
  }
})

onBeforeUnmount(() => {
  if (typeof window !== 'undefined') {
    window.removeEventListener('pointermove', handlePointerMove)
    document.body.removeEventListener('pointerleave', handlePointerLeave)
  }
})
</script>

<template>
  <div ref="wrapperRef" class="diwali-bg-wrapper" aria-hidden="true">
    <div class="diwali-bg">
      <img src="~/assets/images/home/event_background_bg.svg" alt="Event Festive Background" />
    </div>
    <div class="pointer-light" />
  </div>
</template>

<style scoped>
.diwali-bg-wrapper {
  position: fixed;
  inset: 0;
  z-index: -2;
  width: 100%;
  height: 100%;
  pointer-events: none;
  overflow: hidden;
  background: #fff;
}

.diwali-bg {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  z-index: -2;
}

.diwali-bg img {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
}

.pointer-light {
  position: absolute;
  inset: 0;
  z-index: 0;
  pointer-events: none;
  background: radial-gradient(
    280px circle at var(--mx, 50%) var(--my, 45%),
    rgba(255, 218, 139, 0.24),
    rgba(255, 245, 222, 0.12) 35%,
    transparent 72%
  );
  opacity: var(--pointer-opacity, 0);
  transition: opacity 0.35s ease;
}
</style>
